import { ActionReducerMap } from '@ngrx/store';

import * as fromTaskboard from '../taskboard-ngrx/store/taskboard.reducers';

export interface AppState {
  task: fromTaskboard.State;
}

export const appReducer: ActionReducerMap<AppState> = {
  task: fromTaskboard.taskReducer
};
